export default "__VITE_ASSET__ClIYke_K__"